<template>
  <div>
    <div style="margin-top: -24px; margin-left: 15px">
      <el-input
        size="small"
        style="width: 400px"
        placeholder="输入场景名称查询"
        @keyup.enter="handleSearchByText"
        v-model="searchText"
      >
        <template #append>
          <el-button @click="handleSearchByText"
            ><i class="iconfont icon-sousuo"></i><span>查询</span></el-button
          >
        </template>
      </el-input>
    </div>
    <div v-loading="loading" class="table-wrapper">
      <el-table
        :data="tableData"
        height="calc(100vh - 260px)"
        size="default"
        @sort-change="handleSortChange"
        border
      >
        <el-table-column width="66">
          <template #default="scope">
            <el-button
              @click="rowClick(scope.row)"
              link
              type="primary"
              size="small"
              style="padding: 0"
            >
              <i class="iconfont icon-level-down"></i>
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="scene_name" label="场景名称" width="180">
        </el-table-column>
        <el-table-column prop="scene_path" label="场景路径"> </el-table-column>
        <el-table-column
          prop="dependencies_bundles"
          width="130"
          sortable="custom"
          label="总依赖AB包"
        >
        </el-table-column>
        <el-table-column
          prop="dependencies_assets"
          width="140"
          sortable="custom"
          label="依赖资源总数"
        >
        </el-table-column>
        <el-table-column
          prop="error_dependencies_assets"
          width="140"
          sortable="custom"
          label="错误依赖AB包"
        >
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <el-pagination
          background
          :page-size="count"
          :current-page="cursor"
          :total="total"
          @current-change="pagechange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script setup>
import { apiPackageParseScene } from "@/Api/AppApi";
import { defineProps, defineEmits, onMounted, reactive, ref } from "vue";

const props = defineProps(["param"]);
const emit = defineEmits(["selectRow"]);

onMounted(() => {
  loadData(searchText.value);
});

const searchText = ref("");
const count = ref(30);
const cursor = ref(1);
const total = ref(0);
function handleSearchByText() {
  count.value = 30;
  cursor.value = 1;
  loadData(searchText.value);
}

let sortColumn = "";
let order = "";
function handleSortChange(evt) {
  sortColumn = evt.prop;
  order = evt.order;
  loadData(searchText.value);
}

function pagechange(pagenum) {
  cursor.value = pagenum;
  loadData(searchText.value);
}

function rowClick(row) {
  const data = {
    viewType: "scenedetail",
    name: row.scene_name,
  };
  emit("selectRow", data);
}

const loading = ref(false);
const tableData = ref([]);
async function loadData(search) {
  const params = {
    version_id: props.param.versionid,
    cursor: cursor.value,
    count: count.value,
  };

  if (search != undefined && search.length > 0) {
    params.scene_path = search;
  }
  if (sortColumn != undefined && sortColumn.length > 0) {
    params.sort_field = sortColumn;
  }
  if (order != undefined && order.length > 0) {
    params.order = order;
  }

  loading.value = true;
  const res = await apiPackageParseScene(params);
  loading.value = false;
  if (res.code === 0) {
    total.value = res.data.total;
    tableData.value = res.data.list;
  }
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  margin-top: 8px;
  width: 100%;
  background: #fff;
  padding: 15px 15px 0 15px;
  height: calc(100vh - 190px);

  :deep() {
    .el-table__inner-wrapper,
    .el-scrollbar__wrap {
      height: 100% !important;
    }

    .el-table__body-wrapper {
      height: calc(100% - 40px) !important;
    }
  }
}

.pagination-wrapper {
  display: flex;
  background-color: #ffffff;
  justify-content: center;
  padding: 5px 0;
  height: 46px;
}
</style>
